import vs from './BackgroundMaterial.vert?hotshader';
import fs from './BackgroundMaterial.frag?hotshader';

import { ShaderMaterial, Vector2 } from 'three';

function generateRandomDecimalInRangeFormatted(min, max, places) {
	const value = Math.random() * (max - min);
	return Number.parseFloat(value).toFixed(places);
}

export default class BackgroundMaterial extends ShaderMaterial {
	constructor(params = {}) {
		super();

		const redRandom = generateRandomDecimalInRangeFormatted(0, 0.5, 3);
		const greenRandom = generateRandomDecimalInRangeFormatted(0, 0.25, 3);
		const blueRandom = generateRandomDecimalInRangeFormatted(0.25, 1, 3);

		this.uniforms = {
			u_time: { value: params.uTime || Math.random() * 100.0 },
			u_resolution: { value: new Vector2() },
			u_red: { value: redRandom },
			u_green: { value: greenRandom },
			u_blue: { value: blueRandom },
		};

		this.type = 'BackgroundMaterial';
		this.isShaderMaterial = true;

		vs.use(this);
		fs.use(this);
	}
}
